import styled from "styled-components";

interface ITooltipGradientProps {
    gradientColor?: string;
}
export const TooltipGradient = styled.div<ITooltipGradientProps>(({ theme, gradientColor }) => ({
    position: "absolute",
    bottom: 0,
    left: 0,
    width: "100%",
    height: "100px",
    background: gradientColor && `linear-gradient(151deg, #FFF 51.16%, ${gradientColor} 106.07%)`,
    borderBottomLeftRadius: theme.spacing.small,
    borderBottomRightRadius: theme.spacing.small,
    zIndex: 2,
}));

export const TooltipContent = styled.div({
    position: "relative",
    zIndex: 3,
});
